import { useMutation } from '@tanstack/react-query'
import { postContactInstrument } from 'services/ContactService'

export const usePostContactInstrumentMutation = () => {
  return useMutation({ mutationFn: postContactInstrument })
}
